
<div class="w-full flex justify-center bg-[#f9f8f6] font-rubik quote-builder-sub-header-container">
  <div class="w-full max-w-[1440px] flex flex-col quote-builder-sub-header-inner-container">
    <picture class="quote-builder-subheader-picture">
      <source
        media="(max-width: 1024px)"
        srcset="@/images/quote-builder/quote-builder-banner-mobile.png"
      />
      <img
        class="quote-builder-subheader-img"
        src="@/images/quote-builder/quote-builder-banner.png"
        alt="Banner image"
      />
    </picture>
    <div class="flex justify-between items-center p-5 quote-builder-sub-header-bottom-half">
      <div class="w-full flex flex-col gap-3">
        <div class="w-full flex justify-between">
          <h1>Contact Us</h1>
          <button @click="home()" class="flex justify-center items-center transition-all">
            <img src="@/images/quote-builder/home.svg" alt="Return to home page">
          </button>
        </div>
        <p>
          Container Alliance is the leader in storage container sales and leasing, shipping container sourcing and portable storage services. 
          <br>We offer new and used containers customized to your application. Contact us today for a custom quote 1-866-398-278.
        </p>
      </div>
    </div>
  </div>
</div>
